import {
  Container,
  Content,
  Description,
  Link,
} from './ResidentNotification.style';

import Error from 'shared/icons/Error';

const ResidentNotification = () => {
  return (
    <Container>
      <Error
        sx={{
          fontSize: '1.2rem',
          color: (theme) => theme.palette.primary.main,
        }}
      />
      <Content>
        <Description>
          Sisään-/poismuuttoilmoitukset tulee tehdä Kiinteistötahkolan
          kotisivujen kautta osoitteessa{' '}
        </Description>
        <Link
          href="https://kiinteistotahkola.fi/ilmoita-muutosta/"
          target="_blank"
          rel="noreferrer"
        >
          https://kiinteistotahkola.fi/ilmoita-muutosta/
        </Link>
      </Content>
    </Container>
  );
};

export default ResidentNotification;
